/* Native scrolling keeps every excerpt available even without JavaScript. */
if (!customElements.get('member-quotes-carousel')) {
  customElements.define('member-quotes-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.member-quotes__track');
      this.pagination = this.querySelector('.member-quotes__pagination');
      this.slides = Array.from(this.track.children);
      this.events = new AbortController();
      const options = { signal: this.events.signal };

      this.track.addEventListener('scroll', () => this.updateActivePage(), { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track) return;
        const pages = this.pagination.children.length;
        let page = this.activePage;
        if (event.key === 'ArrowRight') page += 1;
        else if (event.key === 'ArrowLeft') page -= 1;
        else if (event.key === 'Home') page = 0;
        else if (event.key === 'End') page = pages - 1;
        else return;
        event.preventDefault();
        this.goToPage(Math.max(0, Math.min(page, pages - 1)));
      }, options);

      this.pagination.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (button) this.goToPage(Number(button.dataset.page));
      }, options);

      this.resizeObserver = new ResizeObserver(() => this.buildPagination());
      this.resizeObserver.observe(this.track);
      this.buildPagination();
    }

    disconnectedCallback() {
      this.events.abort();
      this.resizeObserver.disconnect();
    }

    buildPagination() {
      const perView = Number(getComputedStyle(this).getPropertyValue('--quotes-per-view')) || 1;
      if (perView !== this.perView) {
        this.perView = perView;
        this.pagination.replaceChildren();
        const pages = Math.ceil(this.slides.length / perView);
        for (let page = 0; page < pages; page += 1) {
          const button = document.createElement('button');
          const first = Math.min(page * perView, this.slides.length - perView) + 1;
          const last = Math.min(first + perView - 1, this.slides.length);
          button.type = 'button';
          button.className = 'member-quotes__dot';
          button.dataset.page = page;
          button.setAttribute('aria-label', first === last ? `Show excerpt ${first}` : `Show excerpts ${first} to ${last}`);
          button.setAttribute('aria-controls', this.track.id);
          this.pagination.append(button);
        }
        this.pagination.hidden = pages < 2;
      }
      this.updateActivePage();
    }

    pageOffset(page) {
      const slide = this.slides[page * this.perView];
      return Math.min(slide.offsetLeft - this.slides[0].offsetLeft, this.track.scrollWidth - this.track.clientWidth);
    }

    goToPage(page) {
      this.track.scrollTo({
        left: this.pageOffset(page),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }

    updateActivePage() {
      const buttons = Array.from(this.pagination.children);
      this.activePage = buttons.reduce((closest, _, page) =>
        Math.abs(this.pageOffset(page) - this.track.scrollLeft) < Math.abs(this.pageOffset(closest) - this.track.scrollLeft) ? page : closest, 0);
      buttons.forEach((button, page) => {
        button.setAttribute('aria-current', String(page === this.activePage));
      });
    }
  });
}
